<template>
    <div class="rule-page">
        <h1>隐私与知识产权说明</h1>

        <h2>探物是一个试用新奇酷产品和分享的平台</h2>
        <p>请仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不进入探物。当您注册成功，无论是进入探物，还是在探物上发布任何内容，均意味着您（即「用户」）完全接受本协议项下的全部条款。</p>

        <h2>隐私声明</h2>
        <p>探物科技（以下简称探物）非常重视对您的个人隐私保护，有时候我们需要某些信息才能为您提供您请求的服务，本隐私声明解释了这些情况下的数据收集和使用情况，并适用于探物开展的所有相关服务</p>
        <p>信息的收集和使用</p>

        <h2>我们收集哪些信息</h2>
        <p>1）在您创建或修改探物账号、使用探物产品和服务、联系客户支持或其他情况时，我们将会收集您直接向我们提供的信息，该信息包括但不限于：姓名、电话号码、电子邮箱、地址、银行卡信息、付款方式和您选择提供的其他信息。 </p>
        <p>2）通过您使用和访问探物app和探物服务时，我们会收集关于您以下信息：同时也会收集其他与您相关的信息（包括但不限于设备信息、日志信息、位置信息、应用启动数，页面访问数，重点按钮点击数，设置项的配置属性等诸类类似的特征记</p>
        
        <h2>我们可能将收集的信息用作下列用</h2>
        <p>1）向您提供服务</p>
        <p>2）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性</p>
        <p>3）帮助我们设计新服务，改善我们现有服务</p>
        <p>4）使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如内容喜好、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应</p>
        <p>5）评估我们服务中的内容数量、内容形式的效果，并加以改善</p>
        <p>6）软件认证或管理软件升级</p>
        <p>7）让您参与有关我们产品和服务的调查</p>
        <p>8）信息的披露与安全</p>

        <h2>关于信息披露</h2>
        <p>探物会在法律要求或符合探物的相关服务条款或本隐私声明载明的例外情况下透露您的个人信息，或者有充分理由相信必须这样做才能： </p>
        <p>1）满足法律或行政法规的明文规定，或者符合探物适用的法律程序； </p>
        <p>2）符合探物相关服务条款、软件许可使用协议的约定； </p>
        <p>3）保护探物的权利或财产； </p>
        <p>4）在紧急情况下保护探物员工、探物产品及服务的用户或大众的个人安全。 </p>
        <p>探物不会未经您的允许将这些信息与第三方共享，本声明已经列出的上述情况除外</p>

        <h2>安全性说明</h2>
        <p>1）探物科技将严格遵守有关法律法规和本隐私政策所载明的内容收集、使用您的信息。除非持有探物科技官方出具的授权文件，否则探物科技的具体工作人员不会直接向您索要个人信息。如遇此类情况，您可以直接与探物科技联系。</p>
        <p>2）探物科技将尽合理的努力保障您的信息安全，使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题</p>

        <h2>知识产权声明</h2>
        <p>1）探物是一个信息获取、分享及传播的平台，我们非常尊重和鼓励探物用户进行内容创作，同时会为用户的创作内容进行知识产权保护。 </p>
        <p>2）用户在探物上发表的全部原创评测和评论，著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要得到探物的同意。</p>
        <p>3）探物提供的网络服务中包含的标识、文本、图片、视频等均受著作权、商标及其它法律保护，未经相关权利人（含探物及其他原始权利人）同意，上述内容均不得在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。</p>
        <p>4）探物为用户提供「保留所有权利，禁止转载」的选项。除非获得原作者的单独授权，并邮件通知我们 (邮箱：hello@tanwuapp.com )，任何第三方不得转载标注了「禁止转载」的内容，否则均视为侵权。 </p>
        <p>5）在探物上传或发表的内容，用户应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，探物有权根据实际情况删除相关的内容有权追究用户的法律责任，给探物或任何第三方造成损失的，用户应负责全额赔偿。</p>
        <p>6）如果任何第三方侵犯了探物用户相关的权利，用户同意授权探物或其指定的代理人代表探物自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在探物认为必要的情况下参与共同维权。 </p>
        <p>7）探物有权但无义务对用户发布的内容进行审核，有权根据相关证据结合《侵权责任法》、《信息网络传播权保护条例》等法律法规对侵权信息进行处理。 如个人或单位发现探物上存在侵犯其自身合法权益的内容，请及时与我们取得联系（邮箱：hello@tanwuapp.com )，并提供具有法律效力的证明材料，以便探物作出处理。 </p>
        <p>8）用户发表并将其上传探物的任何内容，探物不限形式和载体地享有永久的、不可撤销的、免费的、非独家的使用权和转授权的权利，包括但不限于修改、复制、发行、展览、改编、汇编、出版、翻译、信息网络传播、广播、表演和再创作及著作权法等法律法规确定的其他权利。 </p>
        <p>9）使用探物的任何内容均应注明“来源于探物”及署上作者姓名，按法律规定需要支付稿酬的，应当通知探物及作者及支付酬金，并独立承担一切法律责任。
        <p>10）恶意转载探物内容的，本平台保留将其诉诸法律的权利</p>
    </div>
</template>

<script>
    export default {
		data() {
            return {}
        },
    }
</script>

<style lang="scss">
   
</style>



// WEBPACK FOOTER //
// src/pages/content/children/serverTerms.vue